module.exports = __webpack_public_path__ + "media/images/workplace/banners/uhrs_qualify_banner_variant2_image-ee72f773f390c6d8e5b77a2af0d95aa9.jpg";